import React, {Component} from 'react';
import {Link, Switch, Route } from 'react-router-dom';
import {withRouter} from 'react-router';
import { updateUser } from '../../../actions/user';
import { connect } from 'react-redux'


import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButton
} from "reactstrap";

class Update extends Component {

    constructor(props) {
        super(props);

        this.state = {
            username: this.props.user.username,
            password: '',
            passwordRepeat: ''
        };

        this.fieldChanged = this.fieldChanged.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }

    fieldChanged(e) {
        this.setState({
            [e.target.getAttribute('name')] : e.target.value
        })
        
    }

    submitForm(e) {
        e.preventDefault();
        
        this.props.updateUser(this.props.clientPath.clientPath + '/api/user/action/update', this.props.user.userId, this.state);

    }
    render() {

        return (
            <div className="animated fadeIn">

                <Row>
                    <Col xs="12" md="12">
                        <Card>
                            <CardHeader>
                            <strong>Update</strong> account
                        </CardHeader>

                        <CardBody>
                            <form onSubmit={(e) => this.submitForm(e)} className="form-horizontal">
                                <FormGroup row>

                                    <Col md="3">
                                        <Label htmlFor="username">Gebruikersnaam</Label>
                                    </Col>

                                    <Col xs="12" md="9">
                                        <Input type="text" readOnly="true" id="username" onChange={this.fieldChanged} name="username" defaultValue={this.props.user.username} placeholder="Vul je gebruikersnaam in"/>
                                    </Col>

                                </FormGroup>

                                <FormGroup row>
                                    <Col md="3">
                                        <Label htmlFor="password">Wachtwoord</Label>
                                        <br />
                                    </Col>

                                    <Col xs="12" md="9">
                                        <Input type="password" id="password" onChange={this.fieldChanged} name="password" placeholder="Vul je wachtwoord in"/>
                                        <br />
                                    </Col>

                                    <Col md="3">
                                        <Label htmlFor="passwordRepeat">Wachtwoord herhalen</Label>
                                    </Col>

                                    <Col xs="12" md="9">
                                        <Input type="password" id="passwordRepeat" onChange={this.fieldChanged} name="passwordRepeat" placeholder="Herhaal je wachtwoord"/>
                                        <br />
                                        {this.state.password === this.state.passwordRepeat ? '' : <div className="alert alert-danger">Wachtwoorden zijn niet gelijk.</div>}
                                    </Col>
                                </FormGroup>
                            </form>
                        </CardBody>

                        <CardFooter>
                            <Button type="submit" onClick={this.submitForm} size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
                        </CardFooter>
                    </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}
 
function mapStateToProps(state, ownProps) {
 
    return {
        user: state.UserReducer,
        clientPath: state.clientPathReducer 
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateUser: (url, userId, postData) => dispatch(updateUser(url, userId, postData)),
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Update))



// WEBPACK FOOTER //
// ./src/components/Account/Update/index.js